import React, { Fragment } from "react";
import billpayBanner from "assets/images/billpay_banner.jpg";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import BillpayContent from "./content";
import BillpayHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function BillPayInfo() {
  useDocumentTitle(
    "Pay Utility Bills & More | YOOZ",
    "Pay Flow, Digicel, Green Dot utilities and more all in one place. Pay online anytime or pay in cash at over 120 Agent Locations nationwide. Easy, Safe, Fast."
  );
  return (
    <Fragment>
      <PageBanner img={billpayBanner} />
      <ContentWrapper>
        <BillpayHeader />
        <BillpayContent />
      </ContentWrapper>
    </Fragment>
  );
}
